import base from "@/store/utils/api-route/base";

const metaAPI = {
    sapaan: `${base.meta}list_data_sapaan`,
    agama: `${base.meta}list_data_agama`,
    karyawan: `${base.meta}list_karyawan_tiny_meta`,
    tahapan: `${base.meta}tahapan_meta`,
    mesin: `${base.meta}list_mesin_tiny_meta`,
    akunKeuangan: `${base.meta}list_akun_keuangan`,
    akunDebit: `${base.meta}list_detail_kas_bank`,
    dataMCoin: `${base.meta}data_coin_owner`,
    getShortcode: `${base.masterData}whatsapp/list_shortcode`,
    akunEDC: `${base.meta}list_detail_kas_edc`,
    workshop: `${base.meta}list_workshop_meta_tiny`,
    akunKeuanganGlobal: `${base.meta}list_akun_keuangan_global`,
    listKeuanganKasOutlet: `${base.masterData}keuangan/list_keuangan_kas`,
    listKeuanganKasWorkshop: `${base.masterData}keuangan/list_keuangan_kas_workshop`,
    listKeuanganBiaya: `${base.masterData}keuangan/list_keuangan_biaya`,
    listKeuanganOwner: `${base.masterData}keuangan/list_rekening_owner`,
    listBiayaItemKategori: `${base.masterData}keuangan/list_biaya_item_kategori`,
    getDahsboardInfo: `${base.meta}get_dashboard_content`,
    listFinancialAccountFund: `${base.meta}list_financial_account_fund`,
    listAssetsAccount: `${base.meta}list_assets_account`,
    listKonsumenV2: `${base.meta}list_data_konsumen_v2`,
    listKonsumenTiny: `${base.meta}list_tiny_konsumen`,
    betaFeatureOwnerAccess: `${base.auth}beta_feature_owner_access`,
    showQrisManagementMenu: `${base.masterData}qris_ticketing/show_qris_management_menu`,
    new_owner_beta: `${base.masterData}owner/new_owner_beta`,
    setBetaFeature: `${base.masterData}owner/beta_feature`,
	topServiceSummary: `${base.masterData}dashboard/top_services_summary`,
	ownerToken: `${base.meta}owner_token`,

};

export default metaAPI;
